import React, { FC, useState } from "react";
import {
  SOL_DECIMAL_PLACES,
  SOL_SYMBOL,
} from "../../../../../common/constants/common.constants";
import WizardField from "../../../../WizardField/WizardField";
import infoCircle from "../../../../../assets/infoCircle.svg";
import ProposalTooltip from "../../ProposalTooptip/ProposalTooltip";
import {
  ICreateProposalForm,
  ICreateProposalProps,
} from "../../../../../common/interfaces/proposals.interface";
import "./MintPrice.scss";
import { ProposalBuyOption } from "../../../../../common/enums/proposals.enums";
import { useFormikContext } from "formik";
import MintSelect from "../../TransferProposal/MintSelect/MintSelect";
import { clubsStore } from "../../../../../contexts/clubStore";

const MintPrice: FC<{
  form: ICreateProposalProps;
  validateNftMint: () => void;
}> = ({ form, validateNftMint }) => {
  const [isTooltipVisible, toggleIsTooltipVisible] = useState(false);
  const { values, setFieldValue } = useFormikContext<ICreateProposalForm>();
  const { treasury } = clubsStore();
  return (
    <div className="mint-price">
      <img
        onMouseEnter={() => toggleIsTooltipVisible(true)}
        onMouseLeave={() => toggleIsTooltipVisible(false)}
        className="mint-price__info-circle"
        src={infoCircle}
        alt="infoCircle"
      />

      <div className="mint-price__tooltip">
        {isTooltipVisible && (
          <ProposalTooltip
            handleMouseEnter={() => toggleIsTooltipVisible(true)}
            handleMouseLeave={() => toggleIsTooltipVisible(false)}
            tooltipData={[
              {
                tooltipDescription:
                  "Trade NFTs directly with other people, without royalties or any other fees. Paste Token ID that can be found in any URL from any block explorer.",
                tooltipTitle: "P2P (Peer to Peer)",
              },
              {
                tooltipDescription:
                  "Purchase NFTs from the Magic Eden marketplace. Note that the seller might change the initially given price.",
                showIcon: true,
                tooltipTitle: "Magic Eden",
                tootlipExternalLink:
                  "https://uniquevc.gitbook.io/unique-venture-clubs-docs/",
              },
            ]}
          />
        )}
      </div>
      <WizardField
        type="text"
        placeholder="Paste NFT link"
        label={form.formFields.nftToBuy.label}
        name={form.formFields.nftToBuy.name}
        validateField={validateNftMint}
        isBuyTooltip
        required
      />

      <div className="mint-price__price-container">
        <WizardField
          type="number"
          name={form.formFields.price.name}
          label={form.formFields.price.label}
          disabled={values.buyOption !== ProposalBuyOption.PeerToPeer}
          placeholder="NFT price here"
          required
          tooltipTitle={
            values.buyOption !== ProposalBuyOption.PeerToPeer
              ? "If the Club’s Main currency is not SOL but any other from the SPL token list, in order to buy NFTs from Magic Eden or SolSea, you will need to transfer SOL in the Treasury."
              : ""
          }
          leftPosition={-7.2}
          maxDecimalsLength={SOL_DECIMAL_PLACES}
          persistentPlaceholder={
            values.buyOption !== ProposalBuyOption.PeerToPeer
              ? SOL_SYMBOL
              : undefined
          }
        />
        {treasury && values.buyOption === ProposalBuyOption.PeerToPeer && (
          <MintSelect
            treasuryTokenAccounts={treasury.tokenAccounts}
            isForm
            setFieldValue={setFieldValue}
            chosenMint={treasury.denominatedTokenInfo?.mint.toString()}
          />
        )}
      </div>
    </div>
  );
};

export default MintPrice;
